export default "{% block impressum %}\n\n{% endblock %}";